import * as React from 'react'
// views
import { ActionsIcon, ChartIcon, FunctionIcon, ImageIcon, SectionIcon, CardIcon } from './views'

export const getDashboardWidgetIcon = (type: string): React.ReactNode => {
  switch (type) {
    case 'SECTION': {
      return <SectionIcon />
    }
    case 'IMAGE': {
      return <ImageIcon />
    }
    case 'FUNCTION': {
      return <FunctionIcon />
    }
    case 'CARD': {
      return <CardIcon />
    }
    case 'STRATEGY_ACTIONS': {
      return <ActionsIcon />
    }
    case 'CHART': {
      return <ChartIcon />
    }
  }
}
